"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const utils_1 = require("./utils");
const classMapping_json_1 = __importDefault(require("./classMapping.json"));
let mapping = classMapping_json_1.default;
const _parseTokens = tokens => {
  tokens.forEach(token => {
    if (/(_open$|image|hr)/.test(token.type) && mapping[token.tag]) {
      const addition = (0, utils_1.toArray)(mapping[token.tag]);
      (0, utils_1.addClassToToken)(token, addition);
    }
    if (token.children) {
      _parseTokens(token.children);
    }
  });
};
const _parseState = state => {
  _parseTokens(state.tokens);
};
const trilogyClass = (md, _mapping) => {
  mapping = _mapping || mapping;
  md.core.ruler.push('markdownit-tag-to-trilogy-class', _parseState);
};
exports.default = trilogyClass;
